// @flow
import prepareString from "./prepare_string";

export default (conditionValue: any) => (fieldValue: any) =>
  prepareString(fieldValue).includes(prepareString(conditionValue));
